import { render, staticRenderFns } from "./LabelPreviewFloater.vue?vue&type=template&id=37d8d82a&scoped=true"
import script from "./LabelPreviewFloater.vue?vue&type=script&lang=js"
export * from "./LabelPreviewFloater.vue?vue&type=script&lang=js"
import style0 from "./LabelPreviewFloater.vue?vue&type=style&index=0&id=37d8d82a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d8d82a",
  null
  
)

export default component.exports